export const HELP_ARTICLES = {
  REACH_SV: "https://help.allears.ai/sv/articles/3765637-hur-fungerar-rackvidd",
  REACH_EN: "https://help.allears.ai/en/articles/3765637-what-is-reach",
};
